// This might not be comprehensive. It was first made for teamStats.
export const lowerIsBetter = new Set([
	"lost",
	"otl",
	"tov",
	"pf",
	"oppFg",
	"oppFga",
	"oppFgp",
	"oppTp",
	"oppTpa",
	"oppTpp",
	"opp2p",
	"opp2pa",
	"opp2pp",
	"oppFt",
	"oppFta",
	"oppFtp",
	"oppOrb",
	"oppDrb",
	"oppTrb",
	"oppAst",
	"oppStl",
	"oppBlk",
	"oppPts",
	"oppMov",
	"pl",
	"drtg",
	"tovp",
	"oppFgAtRim",
	"oppFgaAtRim",
	"oppFgpAtRim",
	"oppFgLowPost",
	"oppFgaLowPost",
	"oppFgpLowPost",
	"oppFgMidRange",
	"oppFgaMidRange",
	"oppFgpMidRange",
	"oppDd",
	"oppTd",
	"oppQd",
	"oppFxf",
	"oppEfg",
	"oppFtpFga",
]);
